/**
 * Developer warnings of the activity tracker (an unknown action name, a disabled action, a bad
 * subject). Off by default; baseService turns them on in a dev build (import.meta.env.DEV is not
 * available here: this module stays importable by jest).
 */
let enabled = false
const warned = new Set<string>()

export const setActivityDevWarnings = (on: boolean) => {
  enabled = on
}

/** Warns once per key, and only when dev warnings are on. */
export const warnActivityOnce = (key: string, message: string) => {
  if (!enabled || warned.has(key)) {
    return
  }
  warned.add(key)
  console.warn(`[activity] ${message}`)
}

/** Tests only: forget which warnings were shown. */
export const resetActivityDevWarnings = () => {
  warned.clear()
}
